import React from 'react';
import { Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import meccaImage from '../../../images/mecca.jpg';

const UmrahCard = ({ role }) => {
    // Both admin and user should go to the same Umrah packages screen for booking
    const linkPath = '/dashboard/umrah-packages';
    
    return (
        <Col className={'mb-4'} xxl={'6'} xl={'6'} lg={'6'} md={'6'}>
            <Link to={linkPath} className='text-decoration-none'>
                <Card className={'card-body text-center'} style={{ 
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${meccaImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    border: 'none',
                    borderRadius: '16px',
                    padding: '40px',
                    minHeight: '300px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'flex-end',
                    transition: 'all .6s',
                    position: 'relative'
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <h4 className={'title text-decoration-none'} style={{ 
                            fontWeight: '700',
                            fontSize: '24px',
                            transition: 'all 0.6s',
                            padding: '12px 20px',
                            background: 'rgba(255,255,255,0.9)',
                            borderRadius: '12px',
                            color: '#333',
                            margin: '0',
                            backdropFilter: 'blur(10px)',
                            boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
                        }}>
                            Umrah Packages
                        </h4>
                    </div>
                </Card>
            </Link>
        </Col>
    );
};

export default UmrahCard;
